module.exports = __webpack_public_path__ + "static/img/2_1@2x.7254aca.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/home/2_1@2x.png
// module id = 4OOF
// module chunks = 8